import logoSvg from "../assets/hiya-logo.svg";

interface HiyaLogoProps {
  width?: number;
  height?: number;
}

export function HiyaLogo({ width = 70, height = 60 }: HiyaLogoProps) {
  return (
    <img
      src={logoSvg}
      alt="Hiya"
      width={width}
      height={height}
      className="text-brand-brown"
    />
  );
}
